import React from "react";
import PropTypes from "prop-types";

import { NewBlackButton } from "../";
import {
    HeroTextH1,
    HeroTextH2,
    HeroTextH4,
    Paragraph,
    CTAsection
} from "./styles";

const Contents = ({
    isHeading1,
    isHeading2,
    isHeading4,
    text,
    subtext,
    button
}) => {
    return (
        <>
            {isHeading1 && <HeroTextH1>{text}</HeroTextH1>}
            {isHeading2 && <HeroTextH2>{text}</HeroTextH2>}
            {isHeading4 && <HeroTextH4>{text}</HeroTextH4>}

            {subtext && <Paragraph>{subtext}</Paragraph>}

            {button && (
                <CTAsection>
                    <NewBlackButton
                        href={button.url}
                        size="medium"
                        target={button.target ? button.target : "_self"}
                        removeBold
                    >
                        {button.text}
                    </NewBlackButton>
                </CTAsection>
            )}
        </>
    );
};

Contents.propTypes = {
    isHeading1: PropTypes.bool,
    isHeading2: PropTypes.bool,
    isHeading4: PropTypes.bool,
    text: PropTypes.string.isRequired,
    subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    button: PropTypes.object
};

export default Contents;
